import type { BodyRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ResponseType = paths['/v3/transactions']['post']['responses']['201']['content']['application/json'];
type TransactionCreateRequestBody = paths['/v3/transactions']['post']['requestBody']['content']['application/json'];

export const createTransaction = async ({ body }: BodyRequest<TransactionCreateRequestBody>) =>
  apiClient.post<ResponseType, ApiClientResponse<ResponseType>>(routes.transactions.create, body);
